module.exports = __webpack_public_path__ + "img/arrow-blue.18cdcb82.svg";